module.exports = __webpack_public_path__ + "static/media/GHLogo.5063c1a0.svg";